var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"measure-wide"},[_c('p',[_vm._v(" This UI concept is developed as part of the MediaScape Project, investigating "),_c('a',{attrs:{"href":"http://www.digitalhumanities.org/dhq/vol/9/1/000205/000205.html","target":"_blank"}},[_vm._v("generous interfaces ↗︎")]),_vm._v(" for audio-visual collections. ")])])
}]

export { render, staticRenderFns }